export default __webpack_public_path__ + "static/media/P2.c1973c83.webp";